import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRefresh01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.693 7.2a9.65 9.65 0 0 1 8.356-4.8 9.65 9.65 0 0 1 8.946 6m-14.372 0H1.8V3.6m18.507 13.2a9.65 9.65 0 0 1-8.356 4.8 9.65 9.65 0 0 1-8.946-6m14.372 0H22.2v4.8"
    />
  </svg>
);
export default SvgArrowRefresh01;
